export const TASA_INTERES = 0.0006934;
export const TASA_INTERES_PORCENTAJE = '28,79%';
export const FACTOR_INTERES = 1;
export const TECNOLOGIA_FIJA = 1000;
export const TECNOLOGIA_VARIABLE = 1100;
export const URL_PAGO = {
  CUPOS:
    'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00003654&origen=buscar',
  MINI_RP:
    'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00009492&origen=buscar',
  PLP: 'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00003654&origen=buscar',
  SIMIL_PAY: 'https://similpay.com/#/biller_code/18608',
  AVAL_PAY:
    'https://www.avalpaycenter.com/wps/portal/portal-de-pagos/web/pagos-aval/resultado-busqueda/realizar-pago-facturadores?idConv=00003654&origen=buscar',
};
export const URL_COMMUNITY =
  'https://rayocol.my.site.com/RecaudosRayoColombia/';
export const CODES_BANKS_LIST = [
  '300',
  '301',
  '302',
  '303',
  '304',
  '324',
  '305',
  '310',
  '311',
  '312',
  '313',
  '314',
  '320',
  '321',
  '322',
  '323',
  '315',
  '316',
  '317',
  '318',
  '319',
  '319',
  '350',
  '351',
  '302',
  '323',
  '324',
  '324',
  '333',
  '333',
];

export const STEPS_CUPO = {
  //SIMULADOR_CREDITO: '1: Simulador',
  INFORMACION_PERSONAL: '1. Creo Cuenta',
  VALIDACIONES: '2. Validación scores y reglas',
  PROPUESTA: '3. Acepto oferta',
  INFORMACION_BANCARIA: '4. Lleno datos bancarios',
  REGISTRO_COMPLETO: '5. Acepto términos',
};
